<template>
  <div>
    <header class="header">
      <div class="head_inner relative flex flex--center">
        <div class="logo">
          <router-link to="/">
            <LOGO></LOGO>
          </router-link>
        </div>
      </div>
    </header>
    <transition name="fade">
      <section
        v-if="loaded"
        class="sec_enter home_enter flex over--hide"
        data-animation="fadeIn"
        data-animated-duration="1s"
        data-animated-delay=".5s"
      >
        <div
          class="
            home_right
            center
            wrap--height
            col--50
            m-100
            flex flex--column
            h-100
            cover
            m_bg_blue
          "
          style="background-image: url('assets/img/layout/bg_login.jpg')"
        >
          <h1 class="title tx--bege">{{ titles[currentStep] }}</h1>
        </div>
        <div
          class="
            home_left
            enter_form
            col--50
            m-100
            flex flex--column flex--center
            center
            m-is--fit
          "
        >
          <LoginForm @changeStep="stepChanged"></LoginForm>
        </div>
      </section>
    </transition>
    <Terms />
  </div>
</template>

<script>
import LOGO from "../assets/img/svg/logo.svg";
import LoginForm from "../components/Login/Login.vue";
import EnterPop from "../components/Popups/EnterPop.vue";
import Terms from "../components/Shared/Terms.vue";

export default {
  name: "Login",
  components: { LOGO, LoginForm, Terms },

  data: function() {
    return {
      loaded: false,
      currentStep: 1,
      titles: {
        1: "MyMedical Doctors",
        2: "MyMedical Doctors",
        3: "ברוכים הבאים"
      }
    };
  },
  mounted() {
    const isMobile = window.innerWidth < 1200;
    const initMobile = localStorage.getItem("init-mobile");
    const initDesktop = localStorage.getItem("init-desktop");
    if (isMobile && !initMobile && navigator.userAgent != "hmcAppUserAgent") {
      localStorage.setItem("init-mobile", true);
      this.$modal.show(EnterPop, { step: "init-mobile" });
    } else if (!isMobile && !initDesktop) {
      localStorage.setItem("init-desktop", true);
      this.$modal.show(EnterPop, { step: "init-desktop" });
    }
    this.loaded = true;
  },
  methods: {
    stepChanged(value) {
      this.currentStep = value.step;
    }
  }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
